
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/roles/create",
      function () {
        return require("private-next-pages/roles/create.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/roles/create"])
      });
    }
  